export const tooltipStyles = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  justifyContent: 'center'
} as const
